import { render, staticRenderFns } from "./eleBox.vue?vue&type=template&id=2ab53b00&scoped=true&"
import script from "./eleBox.vue?vue&type=script&lang=js&"
export * from "./eleBox.vue?vue&type=script&lang=js&"
import style0 from "./eleBox.vue?vue&type=style&index=0&id=2ab53b00&scoped=true&lang=css&"
import style1 from "./eleBox.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab53b00",
  null
  
)

export default component.exports